import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Subject, Observable, Subscription } from 'rxjs';
import { map, switchMap, concatMap, debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { MessageService } from 'primeng/api';

import { GetglobalsettingsService } from '../../services/getglobalsettings.service'
import { CliListEntry } from '../../shared/cli-list-entry';
import { RestApiService } from '../../services/rest-api.service';
import { ClientApiService } from '../../services/client-api.service';

/**
 * Live company text-search panel backed by `ClientApiService.getClientSimpleSearch`.
 *
 * The user types into a bound input field (`something`); both `onSearch` and `onKeyPress` push the
 * current value onto `searchStr$`.  The pipeline inside `ngOnInit` debounces (200 ms), deduplicates,
 * filters for strings longer than 2 characters, then calls `getClientSimpleSearch` via `switchMap`
 * so each keystroke cancels the previous in-flight request.  Results are stored in `companies` for
 * display in a table.
 *
 * The user selects a row (`selection`); `doSearchClientSelect` emits the key fields from that row.
 *
 * **Output:** `selectedIds` emits `{ CLIID, PERSID, CASTCATID, MAINCLIID, MAINPERID }` on row selection.
 */
@Component({
  selector: 'app-company-search',
  templateUrl: './company-search.component.html',
  styleUrls: ['./company-search.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CompanySearchComponent implements OnInit, OnChanges, OnDestroy {

  private clientQuery: Subscription;
  private cliMainQuery: Subscription;

  /** Current text entered in the search input; pushed onto `searchStr$` on every keystroke. */
  something: string = '';
  private searchStr$ = new Subject<string>();

  /** Search results array populated after each debounced API call. */
  companies: any[] = [];

  /** Currently selected row object from the results table. */
  selection: any;

  rows: number = 10;

  /** Title text displayed in the panel or dialog header. */
  @Input()
  header: string = "Поиск организации";

  loading: boolean;

  /** Emits `{ CLIID, PERSID, CASTCATID, MAINCLIID, MAINPERID }` when the user selects a search result row. */
  @Output()
  public selectedIds: EventEmitter<{ 'CLIID': number, 'PERSID': number, 'CASTCATID': number, 'MAINCLIID': number, 'MAINPERID': number }> = new EventEmitter();

  constructor(
    private cliApi: ClientApiService,
    private restapi: RestApiService,
    private messageService: MessageService) { }

  /** Unsubscribes all active HTTP subscriptions to prevent memory leaks. */
  ngOnDestroy(): void {
    if (this.clientQuery) { this.clientQuery.unsubscribe(); }

    if (this.cliMainQuery) { this.cliMainQuery.unsubscribe(); }
  }

  /** Sets up the `searchStr$` → debounced `switchMap(getClientSimpleSearch)` pipeline. */
  ngOnInit(): void {
    this.clientQuery =
      this.searchStr$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        filter((str: string) => str.length > 2),
        switchMap((str: string) => {
          console.log('*** CompanySearchComponent in createProductSubscription: pgn=(' + str + ')');
          this.loading = true;

          return this.cliApi.getClientSimpleSearch(str);
        })
      )
        .subscribe((data) => {
          console.log('*** CompanySearchComponent onSearch subscribe: ');
          this.companies = data;
          this.loading = false;
        });
  }

  /** Reacts to `display` input changes — currently a no-op (body is empty). */
  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** CompanySearchComponent ngOnChanges');
    for (let propName in changes) {
      let change = changes[propName];
      console.log('*** CompanySearchComponent ngOnChanges (actual): ' + propName + ' ' + JSON.stringify(change.currentValue));
      //console.log('*** CompanySearchComponent ngOnChanges (was):    ' + propName + ' ' + JSON.stringify(change.previousValue));

      switch (propName) {
        case 'display':
          if (change.currentValue) {

          }
          break;
      }
    }
  }

  /** Handles the search button click — pushes current `something` text onto `searchStr$`. */
  onSearch(event) {
    console.log('*** CompanySearchComponent onSearch: ' + JSON.stringify(event));
    this.searchStr$.next(this.something);
  }

  /** Handles keyboard input — pushes current `something` text onto `searchStr$` on each keypress. */
  onKeyPress(event) {
    console.log('*** CompanySearchComponent onKeyPress: ' + JSON.stringify(event));
    this.searchStr$.next(this.something);
  }

  /** Handles table row selection — emits `selectedIds` with key fields from `this.selection`. */
  doSearchClientSelect(event) {
    console.log('*** CompanySearchComponent doSearchClientSelect: ' + JSON.stringify(event));

    this.selectedIds.emit({
      'CLIID': this.selection.CLIID,
      'PERSID': this.selection.PERSID,
      'CASTCATID': this.selection.CASTCATID,
      'MAINCLIID': this.selection.MAINCLIID,
      'MAINPERID': this.selection.MAINPERID
    });

  }


}
